<template>
  <div id="app" class="d-flex flex-column h-100">
    <o-app-drawer :items="items" :admin_items="admin_items">
      <template v-slot:brand>
        <span style="color: #f68e1e">O</span
        ><span style="color: #0065b2">com</span>
        <span style="color: #fefefe"> Project Database</span>
      </template>
      ></o-app-drawer
    >

    <o-app-content></o-app-content>

    <o-app-footer version="0.0.1" year="2019"></o-app-footer>
  </div>
</template>

<style>
#nprogress .bar {
  background: #1976d2 !important;
  height: 5px !important;
}

.white--text a {
  color: white;
}
</style>

<script>
import MENU_ITEMS from "./app/menu_items";
import ADMIN_ITEMS from "./app/admin_items";
import OAppDrawer from "./vue-ocom/components/layout/app/OAppDrawer";
import OAppContent from "./vue-ocom/components/layout/app/OAppContent";
import OAppFooter from "./vue-ocom/components/layout/app/OAppFooter";

export default {
  name: "App",
  components: { OAppContent, OAppFooter, OAppDrawer },
  data: () => ({
    admin_items: ADMIN_ITEMS,
    items: MENU_ITEMS,
  }),
  props: {
    source: String,
  },
  created() {
    window.addEventListener("beforeunload", function (event) {
      event.preventDefault();

      event.returnValue = "";
    });
  },
};
</script>
